import { LearnerPageChrome } from "@/pages/learners/page-chrome"
import { SaveButton } from "@/components/shared/action-buttons"
import { PageBody } from "@/components/ui/layout"
import { FormRenderer } from "@/lib/data-driven-forms/renderer"
import { useId } from "react"
import { useFormSchema } from "./form-schema"
import { useNavigate, usePathParam } from "@/lib/page-rendering"

export default function Page() {
  const navigate = useNavigate()
  const formId = useId()
  const titleId = useId()
  const school_id = usePathParam("schoolId")
  const formSchema = useFormSchema()

  const handleSubmit = (data: any) => {
    navigate({
      href: ".",
      method: "post",
      data: {
        relief_listing: {
          school_id,
          ...data,
        },
      },
    })
  }

  return (
    <>
      <LearnerPageChrome
        titleId={titleId}
        action={<SaveButton form={formId} />}
      />
      <PageBody>
        <FormRenderer
          schema={formSchema}
          formId={formId}
          titleId={titleId}
          onSubmit={handleSubmit}
          defaultValues={{
            invite_only: "true",
            details: {
              address: null,
              timetable: {
                timezone_id: Intl.DateTimeFormat().resolvedOptions().timeZone,
              },
              tag_ids: [],
            },
          }}
          registerDirtyDraft
        />
      </PageBody>
    </>
  )
}
